import { AppStateType, useAppStateSelector } from '../Hooks/useAppState';
import "./XTwitter.linaria.module.css!=!./XTwitter?./XTwitter.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNTzWKNyxJTs8yTa/OSM1MzyixMjIpqLCu5dIDyZZVwmXLM1NKMmCSACbIIKM7AAAA"
const styles = "atm_e2_1tcgj5g atm_vy_1tcgj5g";
const XTwitter = () => {
  const darkMode = useAppStateSelector(AppStateType.APP, 'darkMode');
  return <img style={{
    ...(darkMode ? {
      filter: `invert(1)`
    } : null)
  }} src={'/static/icons/x-logo-black.svg'} title="Twitter / X" className={styles} />;
};
export default XTwitter;